<script>
    import { highlight } from "./highlight.js";

    export let filteredResources;
</script>

<p class="resultCount">
    {#key filteredResources}
        <b class="count" in:highlight={{ r: 119, g: 213, b: 223 }}>
            {filteredResources.length}
        </b>
    {/key}
    resources found<slot />
</p>
